<!--<div class="sst_videosPane" id="sst_videosPane">-->
<!--	&lt;!&ndash;ROW 1&ndash;&gt;-->
<!--	<div class="row nomargin nopadding">-->
<!--		<div class="col-4 nomargin nopadding">-->
<!--			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="0">-->
<!--			</sim-screen-container>-->
<!--		</div>-->

<!--		<div class="col-4 nomargin nopadding">-->
<!--			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="1">-->
<!--			</sim-screen-container>-->
<!--		</div>-->

<!--		<div class="col-4 nomargin nopadding">-->
<!--			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="2">-->
<!--			</sim-screen-container>-->
<!--		</div>-->
<!--	</div>-->

<!--	&lt;!&ndash;ROW 2&ndash;&gt;-->

<!--	<div class="row nomargin nopadding">-->
<!--		<div class="col-4 nomargin nopadding">-->
<!--			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="3">-->
<!--			</sim-screen-container>-->
<!--		</div>-->

<!--		<div class="col-4 nomargin nopadding">-->
<!--			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="4">-->
<!--			</sim-screen-container>-->
<!--		</div>-->

<!--		<div class="col-4 nomargin nopadding">-->
<!--			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="5">-->
<!--			</sim-screen-container>-->
<!--		</div>-->
<!--	</div>-->

<!--	<div class="clearfix"></div>-->

<!--</div>-->

<div class="videoContainer">
	<div class="twoByThreeContainer">
		<div class="topLeft aspectRatio169">
			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="0" />
		</div>
		<div class="topCenter aspectRatio169">
			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="1" />
		</div>
		<div class="topRight aspectRatio169">
			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="2" />
		</div>
		<div class="bottomLeft aspectRatio169">
			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="3" />
		</div>
		<div class="bottomCenter aspectRatio169">
			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="4" />
		</div>
		<div class="bottomRIght aspectRatio169">
			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="5" />
		</div>
	</div>
</div>
